{
  "callback": {
    "authenticating": "Connexion en cours",
    "processing": {
      "auth": "Traitement de l'authentification...",
      "exchanging_code": "Échange du code d'autorisation...",
      "success_redirect": "Succès ! Redirection vers le tableau de bord..."
    },
    "success": {
      "title": "Authentification Réussie"
    },
    "error": {
      "title": "Échec de l'Authentification",
      "message": "Nous avons rencontré un problème lors de votre connexion.",
      "try_again": "Réessayer",
      "redirect_message": "Vous serez redirigé vers la page d'accueil dans quelques secondes."
    },
    "info_message": "Veuillez patienter pendant que nous vous connectons de manière sécurisée."
  },
  "logout": {
    "signing_out": "Déconnexion",
    "signing_out_message": "Effacement de votre session...",
    "success_message": "Vous avez été déconnecté avec succès.",
    "logout_completed": "Déconnexion terminée.",
    "signed_out": "Déconnecté",
    "redirect_message": "Vous serez redirigé vers la page d'accueil sous peu.",
    "go_home": "Aller à la Page d'Accueil"
  }
}